import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { getCommonLocale } from 'lib/i18n';
import { formatIdFromName } from 'lib/utility';
import ValidationTypes from 'lib/constants/validationTypes';
import withValidations from 'lib/hocs/withValidations';
import ValidationStore, { removeValidation } from 'lib/stores/validationStore';
import { handleChange } from 'lib/stores/formStore';

const FormImageUploader = ({ name, value, inputClass, required, title = '* Image' }) => {
  const [clearPhoto, setClearPhoto] = useState(false);
  const removePhoto = () => {
    setClearPhoto(true);
    handleChange(null, name);
    ValidationStore.update(s => removeValidation(s, name, ValidationTypes.IMAGE));
    document.getElementById(formatIdFromName(name)).value = '';
  };

  useEffect(() => {
    if (!clearPhoto) return;

    const timer = setTimeout(() => {
      setClearPhoto(false);
    }, 3000);

    return () => {
      clearTimeout(timer);
    };
  }, [clearPhoto]);

  return (
    <div className="mb-3">
      <div className="d-flex align-items-center justify-content-between">
        <div>
          <label htmlFor={name} className="form-label">{title}</label>
          <p className="form-footnote">
            <small><FormattedMessage {...getCommonLocale('invalid_image_upload')} /></small>
          </p>
        </div>
        {value && !required && (
          <button type="button" className="btn btn-primary btn-sm" onClick={removePhoto}>
            Remove Photo
          </button>
        )}
      </div>
      <input
        className={inputClass}
        onChange={e => handleChange(e.target.files[0], name)}
        type="file"
        accept="image/png, image/jpeg"
        id={formatIdFromName(name)}
        name={name}
        data-testid={formatIdFromName(name)}
        required={required}
      />
      {clearPhoto && (
        <p className="text-success mt-1">Image successfully cleared.</p>
      )}
    </div>
  );
};

export default withValidations({
  type: ValidationTypes.IMAGE,
  required: true,
})(FormImageUploader);
